<template>
  <div
    v-if="items.length || canCreate || showDrawActions"
    class="map-project-locations-stack"
  >
    <map-float-panel
      panel-id="gis-locations"
      panel-class="map-project-locations-panel"
    >
      <template #title>
        قطع المشروع
      </template>
      <template #tools>
        <button
          v-if="canCreate"
          type="button"
          class="map-project-locations-panel__add"
          title="إضافة قطعة"
          aria-label="إضافة قطعة"
          @click.stop="$emit('create')"
        >
          +
        </button>
      </template>

      <div class="map-project-locations-panel__list">
        <button
          v-for="item in items"
          :key="item.id || item.title"
          type="button"
          class="map-project-locations-panel__item"
          :class="{ 'is-active': item.active }"
          :title="item.title"
          @click.stop="openAction(item.location)"
        >
          <span class="map-project-locations-panel__item-title">{{ item.title }}</span>
          <span
            v-if="item.meta"
            class="map-project-locations-panel__item-meta"
          >{{ item.meta }}</span>
        </button>
        <p
          v-if="!items.length"
          class="map-project-locations-panel__empty"
        >
          لا توجد قطع بعد
        </p>
      </div>

      <div
        v-if="actionLocation"
        class="map-location-action"
        @click.self="closeAction"
      >
        <div
          class="map-location-action__card"
          role="dialog"
          aria-modal="true"
          :aria-label="actionTitle"
        >
          <p class="map-location-action__title">
            {{ actionTitle }}
          </p>
          <button
            type="button"
            class="map-location-action__btn"
            @click.stop="choose('data')"
          >
            البيانات
          </button>
          <button
            type="button"
            class="map-location-action__btn map-location-action__btn--polygon"
            @click.stop="choose('polygon')"
          >
            المضلع
          </button>
          <button
            type="button"
            class="map-location-action__btn map-location-action__btn--ghost"
            @click.stop="closeAction"
          >
            إلغاء
          </button>
        </div>
      </div>
    </map-float-panel>

    <map-float-panel
      v-if="showDrawActions"
      panel-id="gis-draw"
      panel-class="map-draw-actions-panel"
      :default-collapsed="isSmallScreen()"
    >
      <template #title>
        إجراءات الرسم
      </template>
      <div class="map-draw-actions">
        <div class="map-draw-actions__buttons">
          <button
            type="button"
            class="map-draw-actions__btn"
            :class="{ 'is-active': moveActive }"
            title="نقل المضلع (اسحب من أي رأس أو من داخل المضلع، يلتقط النقاط القريبة)"
            aria-label="نقل المضلع"
            @click.stop="$emit('draw-move')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="5 9 2 12 5 15" />
              <polyline points="19 9 22 12 19 15" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <polyline points="9 5 12 2 15 5" />
              <polyline points="9 19 12 22 15 19" />
              <line x1="12" y1="2" x2="12" y2="22" />
            </svg>
          </button>
          <button
            type="button"
            class="map-draw-actions__btn"
            title="تراجع (Ctrl+Z)"
            aria-label="تراجع"
            :disabled="!canUndo"
            @click.stop="$emit('draw-undo')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="9 14 4 9 9 4" />
              <path d="M20 20v-7a4 4 0 0 0-4-4H4" />
            </svg>
          </button>
          <button
            type="button"
            class="map-draw-actions__btn"
            title="إعادة (Ctrl+Y)"
            aria-label="إعادة"
            :disabled="!canRedo"
            @click.stop="$emit('draw-redo')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="15 14 20 9 15 4" />
              <path d="M4 20v-7a4 4 0 0 1 4-4h12" />
            </svg>
          </button>
        </div>
        <div class="map-draw-actions__list">
          <p
            v-if="!drawHistory.length"
            class="map-draw-actions__empty"
          >
            لا توجد إجراءات بعد
          </p>
          <button
            v-for="(entry, index) in drawHistory"
            :key="entry.id || index"
            type="button"
            class="map-draw-actions__item"
            :class="{ 'is-current': index === drawHistoryIndex }"
            @click.stop="$emit('draw-jump', index)"
          >
            {{ index + 1 }}. {{ entry.label }}
          </button>
        </div>
      </div>
    </map-float-panel>
  </div>
</template>

<script>
import MapFloatPanel from '@/views/modules/projects/Components/MapFloatPanel.vue'

export default {
  name: 'MapProjectLocationsPanel',
  components: {
    MapFloatPanel,
  },
  props: {
    locations: {
      type: Array,
      default: () => [],
    },
    activeLocationId: {
      type: [Number, String],
      default: null,
    },
    canCreate: {
      type: Boolean,
      default: false,
    },
    showDrawActions: {
      type: Boolean,
      default: false,
    },
    drawHistory: {
      type: Array,
      default: () => [],
    },
    drawHistoryIndex: {
      type: Number,
      default: -1,
    },
    moveActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actionLocation: null,
    }
  },
  computed: {
    items() {
      const source = Array.isArray(this.locations) ? this.locations : []
      return source.filter(Boolean).map((location, index) => {
        const land = location.land_number != null ? String(location.land_number).trim() : ''
        const block = location.block_number != null ? String(location.block_number).trim() : ''
        const area = location.area != null && location.area !== '' ? location.area : null
        return {
          location,
          id: location.id,
          title: land ? `${land}` : `موقع ${index + 1}`,
          meta: [block ? `بلوك ${block}` : '', area != null ? `${area}` : ''].filter(Boolean).join(' · '),
          active: this.activeLocationId != null
            && this.activeLocationId !== ''
            && String(location.id) === String(this.activeLocationId),
        }
      })
    },
    actionTitle() {
      const land = this.actionLocation?.land_number
      if (land != null && String(land).trim() !== '') {
        return `قطعة ${land}`
      }
      return 'تعديل القطعة'
    },
    canUndo() {
      return this.drawHistoryIndex > 0
    },
    canRedo() {
      return this.drawHistory.length > 0
        && this.drawHistoryIndex < this.drawHistory.length - 1
    },
  },
  methods: {
    isSmallScreen() {
      return typeof window !== 'undefined'
        && window.matchMedia('(max-width: 767.98px)').matches
    },
    openAction(location) {
      this.actionLocation = location || null
    },
    closeAction() {
      this.actionLocation = null
    },
    choose(kind) {
      const location = this.actionLocation
      this.actionLocation = null
      if (!location) return
      if (kind === 'data') this.$emit('edit-data', location)
      if (kind === 'polygon') this.$emit('edit-polygon', location)
    },
  },
}
</script>

<style scoped>
.map-project-locations-stack {
  pointer-events: none;
}

.map-project-locations-panel__add {
  width: 1.45rem;
  height: 1.45rem;
  border: 1px solid rgba(10, 51, 69, 0.16);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.55);
  color: #0a3345;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
}

.map-project-locations-panel__list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.28rem;
  -webkit-overflow-scrolling: touch;
}

.map-project-locations-panel__item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 0.28rem;
  padding: 0.38rem 0.42rem;
  border: 1px solid rgba(10, 51, 69, 0.1);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.42);
  color: #0a3345;
  text-align: start;
  cursor: pointer;
}

.map-project-locations-panel__item.is-active {
  border-color: rgba(37, 99, 235, 0.45);
  background: rgba(37, 99, 235, 0.16);
}

.map-project-locations-panel__item-title {
  font-size: 0.76rem;
  font-weight: 700;
  line-height: 1.25;
}

.map-project-locations-panel__item-meta,
.map-project-locations-panel__empty {
  font-size: 0.68rem;
  color: rgba(10, 51, 69, 0.72);
  line-height: 1.3;
}

.map-project-locations-panel__empty {
  margin: 0.4rem 0.2rem;
}

.map-draw-actions {
  display: flex;
  flex-direction: column;
  max-height: 9rem;
  padding: 0.28rem 0.4rem 0.4rem;
}

.map-draw-actions__buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  margin-bottom: 6px;
}

.map-draw-actions__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: #fff;
  color: #323232;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  cursor: pointer;
}

.map-draw-actions__btn.is-active {
  background: #e8f1ff;
}

.map-draw-actions__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.map-draw-actions__list {
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.map-draw-actions__empty,
.map-draw-actions__item {
  width: 100%;
  padding: 0.28rem 0.4rem;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #1f2937;
  font-size: 0.72rem;
  text-align: start;
}

.map-draw-actions__item {
  cursor: pointer;
  background: rgba(255, 255, 255, 0.45);
}

.map-draw-actions__item.is-current {
  background: rgba(37, 99, 235, 0.16);
  font-weight: 700;
}

@media (max-width: 767.98px) {
  .map-draw-actions {
    max-height: min(32dvh, 11.5rem);
  }

  .map-draw-actions__btn {
    width: 1.85rem;
    height: 1.85rem;
    min-width: 1.85rem;
    min-height: 1.85rem;
  }
}
</style>
